module.exports = __webpack_public_path__ + "95e132779e7cca1bacc1766332134443.woff2";